import * as React from 'react';
import {connect} from 'react-redux';
// @ts-expect-error
import ReactTooltip from 'react-tooltip';

import {Card} from 'shells/card/card';
import {Link} from 'shells/link/link';
import {Title} from 'shells/typography/title';

import {ListSummaryBar} from '../../../entity-list/header/list-summary/list-summary-bar';

import type {NutshellState} from '../../../../store';

import {getLeadOutcomes} from '../activity-report-selectors';

import styles from './activity-report-summary-chart.module.css';

const DEFAULT_OUTCOME_VALUES = {
    won: 0,
    lostOrCancelled: 0,
    unknown: 0,
} as const;

const OUTCOME_SUMMARIES = {
    won: {
        label: 'Activities with sales',
        key: 'won',
        // @ts-expect-error
        getDataFromStat: (data) => data,
        type: 'integer',
    },
    lostOrCancelled: {
        label: 'Activities with losses',
        key: 'lostOrCancelled',
        // @ts-expect-error
        getDataFromStat: (data) => data,
        type: 'integer',
    },
    unknown: {
        label: 'Other activities',
        key: 'unknown',
        // @ts-expect-error
        getDataFromStat: (data) => data,
        type: 'integer',
    },
} as const;

type StateProps = {
    outcomes: {
        won: number;
        lostOrCancelled: number;
        unknown: number;
    };
};

type Props = StateProps;

function mapStateToProps(state: NutshellState): StateProps {
    return {
        outcomes: getLeadOutcomes(state) || DEFAULT_OUTCOME_VALUES,
    };
}

export class ActivityReportSummaryChartComponent extends React.PureComponent<Props> {
    componentDidMount() {
        ReactTooltip.rebuild();
    }

    render() {
        return (
            <div className={styles['report-chart']}>
                <Card hasBorder={false}>
                    <div className={styles['card-contents']}>
                        <div className={styles.header}>
                            <Title>Activities vs. lead outcomes</Title>
                            <Link
                                variant='primary'
                                href='https://support.nutshell.com/en/articles/8429113-sales-reporting-how-to-use-activity-reports'
                            >
                                What is this report?
                            </Link>
                        </div>
                        {this.renderContents()}
                    </div>
                </Card>
            </div>
        );
    }

    renderContents() {
        const outcomes = this.props.outcomes;
        const totalActivities = outcomes.won + outcomes.lostOrCancelled + outcomes.unknown;

        const winningBarPercent = totalActivities > 0 ? outcomes.won / totalActivities : 0;

        const losingBarPercent =
            totalActivities > 0 ? outcomes.lostOrCancelled / totalActivities : 0;

        const stats = {
            won: getFormattedValue(outcomes.won),
            lostOrCancelled: getFormattedValue(outcomes.lostOrCancelled),
            unknown: getFormattedValue(outcomes.unknown),
        } as const;

        return (
            <div>
                <div className={styles['summary-bar']}>
                    <div
                        style={{width: `${winningBarPercent * 100}%`}}
                        className={styles['summary-bar-section-wins']}
                    />
                    <div
                        style={{width: `${losingBarPercent * 100}%`}}
                        className={styles['summary-bar-section-losses']}
                    />
                    <div className={styles['summary-bar-section-other']} />
                </div>
                <div className={styles.stats}>
                    <ListSummaryBar
                        stats={stats}
                        summaries={OUTCOME_SUMMARIES}
                        appliedStatuses={[]}
                        isFiltering={false}
                        isUnderlined={true}
                        isFirstLoad={!outcomes}
                    />
                </div>
            </div>
        );
    }
}

// TODO: Get these values from the server
function getFormattedValue(value: number) {
    return {
        value: value,
        formatted: value.toLocaleString(),
        prefix: '',
        suffix: '',
    };
}

// @ts-expect-error
const connector = connect<Props, Record<any, any>, _, _, _, _>(mapStateToProps);
export const ActivityReportSummaryChart = connector(ActivityReportSummaryChartComponent);
